import { useSyncExternalStore } from 'react';

/**
 * Tracks whether the first lazily loaded route chunk has arrived. The app uses it to hold back
 * low-priority chrome (the signed-in sidebar) until the page the user came for has its code, so
 * the two never compete for the connection on a slow network.
 */
let routeChunkLoaded = false;
const listeners = new Set<() => void>();

/** Called by the lazy route loaders when a route chunk has been downloaded. */
export function markRouteChunkLoaded(): void {
  if (routeChunkLoaded) return;
  routeChunkLoaded = true;
  listeners.forEach((listener) => listener());
}

/** Test helper: forget that a chunk has loaded. */
export function resetRouteChunkLoaded(): void {
  routeChunkLoaded = false;
  listeners.forEach((listener) => listener());
}

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** True once any lazy route chunk has been downloaded. */
export function useRouteChunkLoaded(): boolean {
  return useSyncExternalStore(subscribe, () => routeChunkLoaded, () => false);
}
